import request from '@/utils/request'

const http = request()

export const listMyMeetings = params => http.post('/project/meetinginfo/listMyMeetings', params)

export const getMeeting = meetingId => http.post('/project/meetinginfo/get', { meetingId })

// export const submitVote = params => http.raw('/project/meetinginfo/submitVote', params)

export const submitVote = params => http.raw('/project/meetinginfo/vote/submit', params)